<template>
	<div class="o-dashboard">

		<div class="o-dashboard__breadcrumbs">
			<ul class="c-breadcrumbs">
				<li>
					<a :href="'/reparaties'">Reparatie overzicht</a>
				</li>
				<li>
					<span>{{repair.order_number}}</span>
				</li>
			</ul>
		</div>

		<div class="o-dashboard__panels" v-if="repair">
			<div class="row collapse">

				<div class="column small-12 xlarge-8">
					<c-block-repair-info :repair="repair"></c-block-repair-info>
					<c-block-activity :activities="repair.events" :client_id="repair.id" type="repair" :max=5 />
				</div>

				<div class="column small-12 xlarge-4">

					<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">
						<div class="c-panel__header">
							<h4 class="c-panel__title margin-b-16">Afbeeldingen</h4>
						</div>
						<div class="c-panel__content">

							<div v-if="imagesUploading" class="margin-b-16 text-center" style="height:100px;">
								<c-loader></c-loader>
							</div>

							<div class="row" v-if="!imagesUploading">
								<div class="column small-6 margin-b-16" v-for="(image, index) in images" :key="index">
									<div @click="openImage(index)" class="c-img-file-input" :style="'background-image:url(' + image.original_url + ')'">
										<div @click.stop="deleteImage(image, index)" class="c-img-file-input__delete">&#10005;</div>
									</div>
								</div>
							</div>

							<input
								@change="uploadImages"
								type="file"
								accept="image/*"
								name="_image"
								ref="imagesUpload"
								multiple
								class="display-none"
							/>

							<button class="c-btn c-btn--hollow no-margin-b" @click="$refs.imagesUpload.click()">Afbeelding(en) uploaden</button>

						</div>
					</div>

					<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">
						<div class="c-panel__header">
							<h4 class="c-panel__title margin-b-16">Offerte</h4>
						</div>
						<div class="c-panel__content">

							<div v-if="quotationUploading" class="margin-b-16 text-center" style="height:100px;">
								<c-loader></c-loader>
							</div>

							<div class="fs-xsmall text-break" v-if="quotation">
								<div class="fw-medium">
									{{ quotation.name }}
								</div>
								<div class="color-secondary td-underline">
									<a :href="quotation.original_url" download class="cursor-pointer margin-r-16">Downloaden</a>
									<span @click="deleteQuotation" class="cursor-pointer" v-if="!invoiceAccepted">Verwijderen</span>
								</div>

								<div v-if="!invoiceAccepted && !invoiceRefused">
									<div class="color-gray-600 margin-t-24" v-if="daysDifference > 30">
										<i>Offerte is verlopen</i>
									</div>

									<div class="color-gray-600 margin-t-24" v-else>
										<i>Offerte is nog {{ 30 - daysDifference }} dag(en) geldig</i>
									</div>
								</div>

								<div class="color-secondary td-underline" v-if="quotation">
									<span @click="modalMailQuotation" class="cursor-pointer">Offerte mailen</span>
								</div>	

								<div class="margin-t-24" v-if="!invoiceAccepted && !invoiceRefused && daysDifference < 30">
									<button class="c-btn c-btn--expanded margin-b-8" @click="acceptOrDenyQuotation($constants.quatation_status.ACCEPTEREN)">Offerte accepteren</button>
									<button class="c-btn c-btn--expanded c-btn--hollow no-margin" @click="acceptOrDenyQuotation($constants.quatation_status.WEIGEREN)">Offerte weigeren</button>
								</div>

								<div class="color-gray-600 margin-t-24" v-if="action_log">
									<i>{{action_log.action}} op {{ datetime(action_log.created_at) }} uur door {{ action_log.user.name }}</i>
								</div>
							</div>

							<div v-if="!quotation">
								<input
									@change="uploadQuotation"
									type="file"
									accept="application/pdf"
									name="_image"
									ref="quotationFile"
									class="display-none"
								/>

								<button type="button" class="c-btn c-btn--hollow no-margin" @click="$refs.quotationFile.click()">
									Offerte uploaden
								</button>
							</div>
						</div>
					</div>

					<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24" v-if="user.roles.some(role => role.name === 'Superuser')">
						<div class="c-panel__header">
							<h4 class="c-panel__title margin-b-16">Opmerkingen</h4>

							<c-textarea
								:label="''"
								:horizontal="false"
								type="textarea"
								name="description"
								v-model="repair_description"/>

							<button class="c-btn c-btn--hollow no-margin-b" @click="saveDescription()">Opslaan</button>

						</div>
					</div>	

				</div>
			</div>
		</div>
	</div>

	<c-change-status v-if="repair.events"
		v-show="changeStatus"
		@close="changeStatus=false"
		@added="load"
		type="delivery"
		:delivery="repair"
		:size="'small'">
	</c-change-status>

	<c-modal v-if="selectedImage" @close="selectedImage = null" class="text-center">
		<img :src="selectedImage.original_url"/>
	</c-modal>

	<c-repair-request v-if="repair"
		v-show="modalRepair"
		:edit="true"
		:delivery="repair"
		@close="modalRepair=false"
		@added="load"
		:size="'medium'"
		:repairDetailView="true">
	</c-repair-request>

	<c-quotation-mail v-if="modalQuatationMail"
		v-show="modalQuatationMail"
		@close="modalQuatationMail=false"
		:contacts="repair.client.contacts.filter(contact => contact.email !== null && contact.deleted_at === null)"
		@mail="mailQuotation"
		:size="'medium'">
	</c-quotation-mail>

</template>

<script>
import View from '@mixins/View';
import Form from '@mixins/Form';
import CTable from '@components/table/Table';
import CBlockRepairInfo from '@components/blocks/RepairInfo';
import CBlockActivity from '@components/blocks/Activity';
import CLoader from '@components/loader/Animation';
import CModal from '@components/Modal';
import CChangeStatus from '@app/modals/ChangeStatus';
import CRepairRequest from '@app/modals/RepairRequest';
import CQuotationMail from '@app/modals/QuotationMail';
import { ref } from 'vue';
import { mapGetters } from 'vuex';

const repair_description = ref('')

export default {
	mixins: [ View, Form ],
	components: { CTable, CBlockRepairInfo, CBlockActivity, CLoader, CModal, CChangeStatus, CRepairRequest, CQuotationMail },

	data() {
		return {
			repair: '',
			changeStatus: false,
			modalRepair: false,
			images: [],
			imagesUploading: false,
			selectedImage: null,
			quotation: null,
			quotationUploading: false,
			invoiceAccepted: false,
			invoiceRefused: false,
			action_log: '',
			repair_description: '',
			modalQuatationMail: false,
		}
	},
	computed: {
		daysDifference() {
			if (!this.quotation || !this.quotation.created_at) {
				return 0;
			}
			const createdAt = new Date(this.quotation.created_at);
			const now = new Date();
			const differenceInTime = now - createdAt;
			const differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));
			return differenceInDays;
		},
		...mapGetters({
			user: 'user/get',
		}),
	},
	methods: {
		modalChangeStatus() {
			this.changeStatus = true;
		},
		modalRepairRequest() {
			this.modalRepair = true;
		},
		modalMailQuotation(){
			this.modalQuatationMail = true;
		},
		mailQuotation(contact){
			this.$xhr.post('/api/deliveries/' + this.$route.params.id + '/mail-quotation/' + contact ).then( ({result}) => {
				this.$store.dispatch('toast/success', {title: 'Offerte mailen', text: 'Offerte is verzonden'});
				this.modalQuatationMail = false;
			}).catch((e) => {
				this.$store.dispatch('toast/alert', {title: 'Offerte mailen', text: 'Offerte kan niet worden verzonden'});
			});
		},	
		uploadImages(event) {
			this.imagesUploading = true;
			let files = Array.from(event.target.files);

			this.$xhr.post('/api/deliveries/' + this.$route.params.id + '/add-images', {files: files}).then( ({result}) => {
				this.images = [];
				this.$store.dispatch('toast/success', {title: 'Afbeeldingen uploaden', text: 'Afbeeldingen zijn geüpload'});
				this.load();
			}).catch((e) => {
				this.$store.dispatch('toast/alert', {title: 'Afbeeldingen uploaden', text: 'Afbeeldingen kunnen niet worden geüpload'});
			});

			this.imagesUploading = false;

		},
		deleteImage(image, index) {

			this.$xhr.post('/api/deliveries/' + this.$route.params.id + '/remove-image', {image: image.id}).then( ({result}) => {
				this.$store.dispatch('toast/success', {title: 'Afbeeldingen verwijderen', text: 'Afbeeldingen zijn verwijderd'});
				this.load();
			}).catch((e) => {
				this.$store.dispatch('toast/alert', {title: 'Afbeeldingen verwijderen', text: 'Afbeeldingen kunnen niet worden verwijderd'});
			});

		},
		openImage(index) {
			this.selectedImage = this.images[index];
		},
		uploadQuotation(event) {

			this.quotationUploading = true;
			let file = event.target.files[0];

			this.$xhr.post('/api/deliveries/' + this.$route.params.id + '/add-quotation', {quotation: file}).then( ({result}) => {
				this.$store.dispatch('toast/success', {title: 'Offerte uploaden', text: 'Offerte is geüpload'});
				this.quotation = result.media.find(media => media.disk === 'quotations');
				this.load();
			}).catch((e) => {
				this.$store.dispatch('toast/alert', {title: 'Offerte uploaden', text: 'Offerte kan niet worden geüpload'});
			});
	
			this.quotationUploading = false;
		},
		deleteQuotation() {

			this.$xhr.post('/api/deliveries/' + this.$route.params.id + '/remove-quotation').then( ({result}) => {
				this.$store.dispatch('toast/success', {title: 'Offerte verwijderen', text: 'Offerte is verwijderd'});
				this.invoiceAccepted = false;
				this.invoiceRefused = false;
				this.quotation = null;
			}).catch((e) => {
				this.$store.dispatch('toast/alert', {title: 'Offerte verwijderen', text: 'Offerte kan niet worden verwijderd'});
			});
		},
		acceptOrDenyQuotation(status){

			this.$xhr.post('/api/deliveries/' + this.$route.params.id + '/accept-or-deny-quotation', { status: status} ).then( ({result}) => {

				if(status === this.$constants.quatation_status.ACCEPTEREN){
					this.invoiceAccepted = true;
					this.invoiceRefused = false;
				}
				else if(status === this.$constants.quatation_status.WEIGEREN){
					this.invoiceAccepted = false;
					this.invoiceRefused = true;
				}
				
				this.repair.date_quotation = result.date_quotation;

			}).catch((e) => {

			});
		},
		saveDescription(){
			this.$xhr.put('/api/deliveries/' + this.$route.params.id, 
				{ repair_description: this.repair_description 
					
				}).then( ({result}) => {
				this.$store.dispatch('toast/success', {title: 'Opmerkingen opslaan', text: 'Opmerkingen zijn opgeslagen'});
			}).catch((e) => {
				this.$store.dispatch('toast/alert', {title: 'Opmerkingen opslaan', text: 'Opmerkingen kunnen niet worden opgeslagen'});
			});
		},
		datetime(value){
			if ( typeof value == 'string' && value.trim() != '' ) {
				let date = new Date(value);

				if ( isNaN(date.getTime()) === false ) {
					return date.toLocaleDateString('nl-NL', {day: 'numeric', month:'numeric', year: 'numeric',  hour: 'numeric', minute: 'numeric', hour12: false})
				}
    		}
		},
		load(){
			this.$xhr.get('/api/deliveries/' + this.$route.params.id).then( ({result}) => {
				this.repair = result;
				this.images = []
				this.images.push(...this.repair.media.filter(media => media.disk === 'images'));
				this.quotation = this.repair.media.find(media => media.disk === 'quotations');
				this.repair_description = this.repair.repair_description;

				this.action_log = this.repair.action_log.find(log => log.action === 'Offerte geweigerd' || log.action === 'Offerte geaccepteerd');	

				if(result.status_quotation === this.$constants.quatation_status.ACCEPTEREN){
					this.invoiceAccepted = true;
				}
				else if(result.status_quotation === this.$constants.quatation_status.WEIGEREN){
					this.invoiceRefused = true;
				}
			}).catch((e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Reparatie verzoek kan niet worden opgehaald'});
			});
		}
	},
	created() {
		this.$store.dispatch('listener/on', {
			event: 'change-status',
			listener: this.modalChangeStatus
		});
		this.$store.dispatch('listener/on', {
			event: 'change-repair',
			listener: this.modalRepairRequest
		});

	},
	beforeUnmount() {
		this.$store.dispatch('listener/off', {
			event: 'change-status',
			listener: this.modalChangeStatus
		});
		this.$store.dispatch('listener/off', {
			event: 'change-repair',
			listener: this.modalRepairRequest
		});
	},

	mounted(){
		this.load();
	}
}
</script>